<div
  #sliderTrack
  class="slider is-flex"
  [ngClass]="styleClass"
  ondragstart="return false;">
    <span
      #sliderRange
      class="slider-range"
      ondragstart="return false;">
    </span>
    <span
      #sliderHandle
      class="slider-handle"
      ondragstart="return false;">
    </span>
</div>
